<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">

          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select
                [(ngModel)]="params.storeIds"
                [multiple]="true"
                (selectChange)="navigate()">
              </hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select
                [(ngModel)]="params.date"
                (selectChange)="navigate()">
              </hx-date-range-select>
            </div>
          </div>

          <div class="m--margin-top-15">
            <button
              type="button"
              (click)="resetFilter()"
              class="btn btn-outline-primary">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <div *ngIf="list.length && !isLoading.list" class="block-table-scroll m--margin-top-30">
            <table class="m--margin-top-10 m--margin-bottom-40 table-report">
              <thead>
              <tr>
                <th class="text-align-center">{{ 'cancel-orders.table.head.fullname' | transloco }}</th>
                <th class="text-align-center">{{ 'cancel-orders.table.head.store' | transloco }}</th>
                <th class="text-align-center">{{ 'cancel-orders.table.head.status' | transloco }}</th>
                <th class="text-align-center">{{ 'cancel-orders.table.head.total' | transloco }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let r of list">
                <tr>
                  <td>{{ r.fullname }}</td>
                  <td>{{ r.storeTitle | uiLabel }}</td>
                  <td>{{ 'cancel-orders.event.' + r.type | transloco }}</td>
                  <td class="txt-right">
                    <a [routerLink]="['../../orders/list']" [queryParams]="{ dateFrom: params.date?.from, dateTo: params.date?.to, activeCart: false, storeId: r.storeId, operatorId: r.userId, actions: (r.type === 'ORDER_REFUNDED') ? 'REFUNDED' : 'CANCELLED', orderBy: 'id' }">
                      {{ r.total | number }}
                    </a>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

        </div>
      </div>
    </div>
  </div>
</div>
